/**
 * Commerce7 Collection Filter - clear filter handle
 */
import { renderVivinoScore } from "./c7-util";

export default function C7Personalization() {


    this.init = () => {
        c7.addAction("c7_personalization_rendered", (content) => {
            // Do something after collection rendered.
            formatPrice()
            createC7Recomendation()
        });
    };

    const formatPrice = () => {
        jQuery(
            ".c7-product__add-to-cart__price span.c7-sr-only + span,.c7-product__add-to-cart__price .c7-price--discounted"
        ).each(function (i, e) {
            let text = jQuery(e).text();
            jQuery(e).text(
                text.replace("$", "").replace(".00", "").replace("Was", "").replace("Now", "")
            );
            jQuery(e).prepend(`<span class="currency">$</span>`)
        });
    }
    const createC7Recomendation = () => {
        jQuery(document).ready(function ($) {
            if ($(".bot__personalization").length) {
                $(".bot__personalization").each(function () {
                    const el = $(this);
                    el.find(".c7-product-collection__product-list").addClass("owl-carousel owl-theme");
                    el.attr('aria-label','carousel');
                    el.find(".c7-product-collection__product-list").owlCarousel({
                        responsive: {
                            0: {
                                items: 1
                            },
                            800: {
                                items: 2
                            },
                            1440: {
                                items: 3
                            }
                        },
                        dots: true,
                        nav: true,
                        navText: [
                            `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 1L6 12L17 23C17 23 14.97 16.455 15 12C15.0291 7.6877 17 1 17 1Z" fill="#20282B"/>
                        </svg>
                        `,
                            `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 1L19 12L8 23C8 23 10.03 16.455 10 12C9.97095 7.6877 8 1 8 1Z" fill="#20282B"/>
                        </svg>
                        `,
                        ],
                    });
                });

                $('.owl-dot').attr('aria-label','dot');
                $('.owl-prev').attr('aria-label','prev');
                $('.owl-next').attr('aria-label','next');
            }
        })
    }
}
